export default __webpack_public_path__ + "static/media/passLogo.8cc982b1.svg";